<template>
  <div id="apply">
     <div class="top">
         <!--
        <div class="btn">
            查询申请中的称号
        </div>
         -->
        <div class="top1" style="margin-top: 10px;">
            <ul>
              <template v-if="!applyList.length">
                <li style="color:red">您暂无申请中的称号！</li>
              </template>
                <li v-if="applyList.length" style="color:red">您已提交以下称号申请，请耐心等待审核结果！</li>
                <li v-for="item in applyList">
                    {{item.name}} 
                    <template v-if="item.status == 0">（审批中）</template>
                    <template v-else-if="item.status == 1">（审批通过）</template>
                    <template v-else-if="item.status == 2">（审批驳回）</template>
                </li>
            </ul>
        </div>
        <div class="btn" @click="backFn()">
            放弃申请，并返回首页
        </div>
     </div>

     <div class="title">
         <van-icon name="play" />申请称号：<span style="color:red">*</span>
     </div>
     <div class="box">
         <!--
          <van-field readonly clickable @click="show=true" class="" v-model="name.titleName" />
         -->
          <div style="position: relative;" class="dddd" @click="show=true" >{{name.titleName}} 
                <van-icon name="arrow-down"  style="position:absolute; right: 15px; top: 15px;"/>
          </div>
          <div class="title" style="margin-top: 20px;padding-left:0px;">
              上传相对应的资质证明：<span style="color:red">*</span>
          </div>
          <div class="titleInfo">
              <van-uploader :preview-full-image="false" v-model="fileList" :after-read="afterRead" style="vertical-align:bottom"/>
              <div style="font-size: 10px; vertical-align:bottom;display:block;">
                <div>*心理学称号请上传相对应的资格证书。</div>
                <span>*其他机构下发的称号，请按该机构指定要求上传相关凭据。</span>
              </div>
          </div>
          <div @click="submitFn()" class="btn" style="text-align:center; margin: 0 auto; margin-top: 50px;width: 130px;">
              提交申请
          </div>
     </div>

     <div class="footer">
        <div>创建新称号，请添加客服</div>
        <img src="@/assets/vip2.png"/>
        <div>专属客服二维码</div>
        <div>其它信息其它信息其它信息</div>
     </div>

     <van-popup v-model="show" position="bottom" :style="{ height: '50%' }">
        <van-picker
          title="标题"
          style="height: 100%;"
          show-toolbar
          values-key="titleName"
          :columns="columns"
          @confirm="onConfirm"
          @cancel="onCancel"
          @change="onChange"
        > 
          <template #option="option">
              <div>
                  <div>{{option.titleName}} {{option.has?'（已拥有）':''}}</div>
              </div>
          </template>
        </van-picker> 
     </van-popup>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant';
export default {
  data() {
    return {
        name: {titleName:''},
        applyList: [],
        show: false,
        url: 'https://metaser.cn:12700/',
        columns: [],
        fileList: [],
    };
  },
  methods: {
      backFn(){
          this.$router.push({path:'/info'})
      },
      submitFn(){
          if(!this.name.title){
            this.$notify('请选择称号'); 
            return false;
          }
          if(!this.fileList.length){
            this.$notify('请选择资质'); 
            return false;
          }
          let params = {};
          params.title = this.name.title;
          let arr = [];
          this.fileList.map(item => {
              arr.push({attachment: item.id})
          })
          params.applyAttachments = arr;
          Toast.loading({
            duration: 100000,
            message: '提交中...',
            forbidClick: true,
          });
          this.$post('api/divination/apply/apply', params)
          .then((res) => {
            Toast.clear();
            Toast.success('提交成功');
            this.$router.back();
          }) 
      },
      getImage(id, type){
          let that = this;
          let params = {
            "id": id,
          }
          let img = '' 
          this.$fetch('api/divination/file/downLoadPicture', params)
          .then((res) => {
              console.log(this.fileList)
              this.fileList[this.fileList.length-1] = {url: (this.url + res), id: id}
          }) 
      },
      afterRead(file){
          let that = this;
          const formData = new FormData();
          formData.append('file', file.file);
          Toast.loading({
            duration: 100000,
            message: '上传中...',
            forbidClick: true,
          });
          this.$postUp('api/divination/file/uploadFile', formData)
          .then((response) => {
              Toast.clear();
              that.getImage(response.data[0],1);
          }) 
      },
      onConfirm(value, index) {
        this.name = value;
        this.show = false;
      },
      onChange(picker, value, index) {
      },
      onCancel() {
        this.show = false;
      },
      skipFn(){
          this.$router.push({path:'/info'})
      },
      getList(){
        let that = this;
        let params = {};
        this.$post('api/divination/apply/getOneSelf', params)
        .then((res) => {
            this.applyList = (res.data ? res.data : []);
        }) 
      },
      init(){
        this.getList();
        let that = this;
        let params = {};
        this.$post('api/divination/user-title/applyGet', params)
        .then((res) => {
            that.columns = res.data;
        }) 
      }
  },
  created(){
    this.init()
  }
};
</script>
<style scope>
#apply .btn{
    background-color: rgba(96, 25, 133);
    border-radius: 25px;
    height: 30px;
    line-height: 30px;
    width: 180px;
    font-size: 16px;
    color:#fff;
    margin: 20px;
    position: relative;
    
}
.top{
  padding-top: 10px;
}
.top1 li{
  font-size: 12px;
  text-align: left;
  padding-left: 30px;
}
.box{
  background: #fff;
  border-radius: 20px;
  border: 1px solid #eee;
  text-align: left;
  padding: 20px;
  width: calc(100% - 60px);
  margin: 0 auto !important;
  padding-bottom: 40px;
  padding-top: 30px;
}
.title{
  font-size: 16px;
  text-align:left;
  width: 100%;
  padding-left: 20px;
  margin: 0 auto;
  margin-bottom: 15px;
}

.titleInfo .van-radio__icon{
  font-size: 13px;
}
.box .van-field{
  border: 1px solid #eee; 
  border-radius: 20px;
}
.footer{
    font-size: 16px;
    margin-top: 30px;
}
.footer img{
    width: 60px;
    height: 60px;
    margin-top: 10px;
    margin-bottom: 5px;
}
.footer div{
    font-size: 10px;
}
.footer div:first-child{
    font-size: 16px;
}
.dddd{
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 0rem 0.32rem;
    overflow: hidden;
    color: #323233;
    font-size: 0.28rem;
    line-height: 40px;
    background-color: #fff;
    border: 0.02rem solid #eee;
    border-radius: 0.4rem;
    height: 40px;
}
</style>

